import { Col, Row } from "react-grid-system";
import { SquareButton2 } from "../atoms";
import { useCreatePropertyContext, useUserLanguage } from "@/customHooks";
import { useEffect, useMemo, useRef, useState } from "react";
import { PropertyCommonsProps } from "@/custom-types";
import styled from "styled-components";

// Icons
import balcony from '@/assets/property-icons/balcony-icon.svg'
import patio from '@/assets/property-icons/patio-icon.svg'
import commonBathroom from '@/assets/property-icons/bathroom-icon.svg'
import kitchen from '@/assets/property-icons/kitchen-icon.svg'
import elevator from '@/assets/property-icons/elevator-icon.svg'
import commonAirConditioner from '@/assets/property-icons/ac-icon.svg'
import commonFan from '@/assets/property-icons/fan-icon.svg'

const textsData = {
  en: {
    balcony: 'Balcony',
    patio: 'Patio',
    commonBathroom: 'Common Bathroom',
    kitchen: 'Kitchen',
    elevator: 'Elevator',
    commonAirConditioner: 'Common A/C',
    commonFan: 'Common Fan',
  },
  es: {
    balcony: 'Balcón',
    patio: 'Patio',
    commonBathroom: 'Baño Común',
    kitchen: 'Cocina',
    elevator: 'Ascensor',
    commonAirConditioner: 'A/C Común',
    commonFan: 'Ventilador Común',
  }
};

const iconMap: Record<string, string> = {
  balcony,
  patio,
  commonBathroom,
  kitchen,
  elevator,
  commonAirConditioner,
  commonFan,
};

const Wrapper = styled.div`
  width: 100%;
  max-width: 800px;
`;

export const CreatePropertySetCommons = () => {
  const { setCommons, setButtonEnabled, state: contextState } = useCreatePropertyContext();
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es : textsData.en;

  const [commonStates, setCommonStates] = useState<PropertyCommonsProps>({
    balcony: contextState.balcony,
    patio: contextState.patio,
    commonBathroom: contextState.commonBathroom,
    kitchen: contextState.kitchen,
    elevator: contextState.elevator,
    commonAirConditioner: contextState.commonAirConditioner,
    commonFan: contextState.commonFan,
  });

  const commonsRef = useRef(commonStates);

  useEffect(() => {
    commonsRef.current = commonStates;
  }, [commonStates]);

  useEffect(() => {
    setButtonEnabled(); // Este paso siempre es válido, no se requiere una selección específica para continuar.
    return () => {
      setCommons(commonsRef.current);
    };
  }, [setButtonEnabled, setCommons]);

  const handleToggle = (key: keyof PropertyCommonsProps) => {
    setCommonStates(prevState => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  const commonButtons: { key: keyof PropertyCommonsProps; text: string }[] = useMemo(
    () => Object.keys(texts).map(key => ({
      key: key as keyof PropertyCommonsProps,
      text: texts[key as keyof typeof texts]
    })),
    [texts],
  );

  return (
    <Wrapper>
      <Row justify="center" gutterWidth={24}>
        {commonButtons.map((btn) => (
          <Col key={btn.key} xs={6} md={3} style={{ marginBottom: '1.5rem' }}>
            <SquareButton2
              action={() => handleToggle(btn.key)}
              selected={commonStates[btn.key]}
            >
              <>
                <img src={iconMap[btn.key]} alt={btn.text} width="48" height="48"/>
                <span>{btn.text}</span>
              </>
            </SquareButton2>
          </Col>
        ))}
      </Row>
    </Wrapper>
  );
};
